import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    standalone: true,
    name: 'keys'
})
export class KeysPipe implements PipeTransform {
    transform($value: {}, $transformUndefined: boolean = false): string[] {
        return $value && typeof $value === 'object'
            ? Object.keys($value)
            : $transformUndefined
                ? []
                : undefined;
    }
}

@Pipe({
    standalone: true,
    name: 'values'
})
export class ValuesPipe<T> implements PipeTransform {
    transform($value: Record<string, T> | Map<any, T>, $transformUndefined: boolean = false): T[] {
        if ($value) {
            if ($value instanceof Map) {
                return Array.from($value.values());
            }

            if (typeof $value === 'object') {
                return Object.keys($value).map($ => $value[$]);
            }
        }
        return $transformUndefined ? [] : undefined;
    }
}

export interface IKeyValuesResult {
    readonly key: string;
    readonly value: any;
}

@Pipe({
    standalone: true,
    name: 'keyValues'
})
export class KeyValuesPipe implements PipeTransform {
    transform($value: {}, $transformUndefined: boolean = false): IKeyValuesResult[] {
        return $value && typeof $value === 'object'
            ? Object.keys($value).map($ => ({key: $, value: $value[$]}))
            : $transformUndefined
                ? []
                : undefined;
    }
}
